import React from "react";
import { Link } from "react-router-dom";
import useFetchApiData from "../helper/useFetchApiData";

const FooterOne = () => {
  const data = useFetchApiData("/config");
  const featured_categories = useFetchApiData("/categories/featured");
  console.warn(featured_categories);
  return (
    <footer className="footer py-40 px-40 bg-light">
      <div className="container container-lg ">
        <div className="footer-item-wrapper d-flex justify-content-between flex-wrap">
          <div className="footer-item">
            <div className="footer-item__logo">
              <Link to="/">
                {" "}
                <img src="https://i.ibb.co/VtYZ856/logo.png" alt="" />
              </Link>
            </div>
            <p className="mb-24">Liquor At Your Doorsteps.</p>
            <div className="flex-align gap-16 mb-16">
              <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                <i className="ph-fill ph-map-pin" />
              </span>
              <span className="text-md text-gray-900 ">
                {data.ecommerce_address}
              </span>
            </div>
            <div className="flex-align gap-16 mb-16">
              <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                <i className="ph-fill ph-phone-call" />
              </span>
              <div className="flex-align gap-16 flex-wrap">
                <Link
                  to={`/mailto:${data.ecommerce_email}`}
                  className="text-md text-gray-900 hover-text-main-600"
                >
                  {data.ecommerce_phone}
                </Link>
              </div>
            </div>
            <div className="flex-align gap-16 mb-16">
              <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                <i className="ph-fill ph-envelope" />
              </span>
              <Link
                to={`/mailto:${data.ecommerce_email}`}
                className="text-md text-gray-900 hover-text-main-600"
              >
                {data.ecommerce_email}
              </Link>
            </div>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">Quick Links</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link
                  to="/terms-and-conditions"
                  className="text-gray-600 hover-text-main-600"
                >
                  Terms & Condition
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/privacy-policy"
                  className="text-gray-600 hover-text-main-600"
                >
                  Privacy Policy
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/return-policy"
                  className="text-gray-600 hover-text-main-600"
                >
                  Return Policy
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/about-us"
                  className="text-gray-600 hover-text-main-600"
                >
                  About Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">Featured Categories</h6>
            <ul className="footer-menu">
              <li className="mb-16"></li>
              {(featured_categories?.featured_data?.length || 0) > 1 &&
                featured_categories?.featured_data.map((item) => (
                  <li className="mb-16" key={item.id}>
                    <Link
                      to={`category/${item.category.id}`}
                      className="text-gray-600 hover-text-main-600"
                    >
                      {item.category.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">My Account</h6>
            <ul className="footer-menu">
  <li className="mb-16">
    <Link
      to={localStorage.getItem("accessToken") ? "/profile-page" : "/login"}
      className="text-gray-600 hover:text-main-600"
    >
      {localStorage.getItem("accessToken") ? "My Account" : "Login"}
    </Link>
  </li>
  <li className="mb-16">
    <Link
      to={localStorage.getItem("accessToken") ? "/order-history" : "/shop"}
      className="text-gray-600 hover:text-main-600"
    >
      {localStorage.getItem("accessToken") ? "Order History" : "Shop"}
    </Link>
  </li>
  <li className="mb-16">
    <Link to="/cart" className="text-gray-600 hover:text-main-600">
      Shopping Cart
    </Link>
  </li>
  <li>
    <Link to="/wishlist" className="text-gray-600 hover:text-main-600">
      Wishlist
    </Link>
  </li>
</ul>

          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">Scan to Pay</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <img
                  src="https://cheers.com.np/resources/images/fonepay-qr.jpg"
                  width={100}
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterOne;
